export default __webpack_public_path__ + "static/media/hero_anchor_a.4772f006.png";